import logo from "./logo.svg";
import "./App.css";
import { useEffect } from "react";
import Home from "./Pages/Home";
import Other from "./Pages/Other";
import DTD from "./Pages/DTD";
import Baitulmaal from "./Pages/Baitulmaal";
import Bloomerang from "./Pages/Bloomerang";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Virtuous from "./Pages/Virtuous";
import Mubarrat from "./Pages/Mubarrat";
import Ali from "./Pages/Ali";
import AliDev from "./Pages/AliDev";
import AliDevFinix from "./Pages/AliDevFinix";
import AddMultipleToCart from "./Pages/AddMultipleToCart";
import FlagTesting from "./Pages/FlagTesting";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quantity" element={<Home />} />
        <Route path="/nodonors" element={<Home hideDonorList />} />
        <Route path="/other" element={<Other />} />
        <Route path="/dtd" element={<DTD />} />
        <Route path="/baitulmaal" element={<Baitulmaal />} />
        <Route path="/bloomerang" element={<Bloomerang />} />
        <Route path="/virtuous" element={<Virtuous />} />
        <Route path="/mubarrat" element={<Mubarrat />} />
        <Route path="/ali" element={<Ali />} />
        <Route path="/alidev" element={<AliDev />} />
        <Route path="/alidevfinix" element={<AliDevFinix />} />
        <Route path="/addMultipleToCart" element={<AddMultipleToCart />} />
        <Route path="/flagtesting" element={<FlagTesting />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
